<template>
   <!-- 无数据tab -->
  <div class="empty-cont">{{text?text:'暂无数据'}}</div>
</template>
<script>
export default {
  props: ['text'],
  data () {
    return {
      statusName:''
    }
  },
  created () {
    
  },
  methods: {

  }
}
</script>
<style>
.empty-cont{
  margin:40px 0;
  font-size: 12px;
  color: #606266;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/pages/workBench/components/emptyTab.vue